import IssueDetails from 'app/developer-v3/pages/issues/IssueDetails';
import IssueList from 'app/developer-v3/pages/issues/IssueList';
import Issues from 'app/developer-v3/pages/issues';
import ZapierIssueManager from 'app/developer-v3/pages/issues/ZapierIssueManager';

export default {
  component: Issues,
  routes: {
    '.': IssueList,
    'zapier-issue-manager': ZapierIssueManager,
    ':issueId': {
      assign: ({ params }) => ({
        params: {
          ...params,
          issueId: parseInt(params.issueId, 10),
        },
      }),
      component: IssueDetails,
    },
  },
};
